module.exports = __webpack_public_path__ + "img/38_17.1603856a.png";